import { appendQueryString } from "@/react/helpers/urlHelpers/appendQueryString";

export const authenticationAppRoutes = {
  discoverSignIn: ({ params = {} } = {}) =>
    appendQueryString("/user/sign_in", params),
  discoverSignUp: ({ params = {} } = {}) =>
    appendQueryString("/user/sign_up", params),
  discoverForgotPassword: () => `/user/password`,
  forgotPassword: ({ params = {} } = {}) =>
    appendQueryString("/users/password/new", params),
  emailLookup: () => "/auth/email_lookup",
  signIn: ({ params = {} } = {}) => appendQueryString("/sign_in", params),
  socialSignIn: (method: string, community_id: number) =>
    `/users/auth/${method}?community_id=${community_id}`,
  signUp: ({ params = {} } = {}) => appendQueryString("/sign_up", params),
  terms: () => "/terms",
  privacy_policy: () => "/privacy",
  /** POST /users/password - Request password reset email; PUT /users/password - Update password with reset token */
  resetPassword: () => "/users/password",
  acceptInvitation: () => "/invitation",
  resendConfirmation: () => "/users/confirmation",
  resendConfirmationPage: () => "/users/confirmation/new",
  optSessions: () => "/auth/otp_sessions",
  resetPasswordOnOtpLogin: () => "/auth/password_reset",
  passwordSetup: () => "/auth/password_setup",
  resendOtp: () => "/auth/otp_sessions/resend",
  two_fa: {
    emailOtpVerification: () => "/two_fa/email_otp/verify",
  },
  communities: {
    new: () => "/communities/new",
    index: () => "/communities",
    update: (community_id: number) => `/communities/${community_id}`,
  },
};
